// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3OLpM","title":"ClientCherryInfo_title__Bcv1B","itemText":"ClientCherryInfo_itemText__3VJqT"};